import { memo } from 'react';
import { AdminTokenUsage } from './TokenUsage/Admin';
import { TierTokenUsageDetails } from './TokenUsage/TierTokenUsageDetails';
import type { OrganizationData } from '~/types/organization';
import type { EffectiveTier } from '~/utils/effectiveTier';

interface TokenUsageProps {
  tier: EffectiveTier;
  activeOrganization: OrganizationData | null;
  closeDialog: () => void;
}

export const TokenUsage = memo<TokenUsageProps>(({ tier, activeOrganization, closeDialog }) => {
  if (tier.plan === 'personal' || tier.plan === 'pro') {
    return <TierTokenUsageDetails tier={tier} closeDialog={closeDialog} />;
  }

  if (tier.plan === 'teams') {
    if (activeOrganization?.role === 'admin') {
      return <AdminTokenUsage closeDialog={closeDialog} activeOrganization={activeOrganization} tier={tier} />;
    } else {
      return <TierTokenUsageDetails activeOrganization={activeOrganization} tier={tier} closeDialog={closeDialog} />;
    }
  }

  return null;
});
